import { cleanToken } from '@nitra/components/njs/token.js'

const routes = [
  {
    path: '/',
    component: () => import('layouts/Layout.vue'),
    children: [
      {
        path: '',
        beforeEnter: (_to, _from, next) => {
          next('/user')
        }
      },
      {
        path: '/knowledge-base',
        meta: { roles: 'admin' },
        component: () => import('pages/KnowledgeBase.vue')
      },
      {
        path: '/call-route',
        meta: { roles: 'admin' },
        component: () => import('pages/CallRoute.vue')
      },
      {
        path: '/user',
        meta: { roles: 'admin-user' },
        component: () => import('pages/User.vue')
      },
      {
        path: '/user-group',
        meta: { roles: 'admin' },
        component: () => import('pages/UserGroup.vue')
      },
      {
        path: '/user-role',
        meta: { roles: 'admin' },
        component: () => import('pages/UserRole.vue')
      },
      {
        path: '/label',
        meta: { roles: 'admin' },
        component: () => import('pages/Label.vue')
      },
      {
        path: '/field',
        meta: { roles: 'admin' },
        component: () => import('pages/Field.vue')
      },
      {
        path: '/issue-title',
        meta: { roles: 'admin' },
        component: () => import('pages/IssueTitle.vue')
      },
      {
        path: '/sms-templates',
        meta: { roles: 'admin' },
        component: () => import('pages/SmsTemplates.vue')
      },
      {
        path: '/upload-pos-contacts',
        meta: { roles: 'admin' },
        component: () => import('pages/UploadPosContacts.vue')
      },
      {
        path: '/atlas-scenes',
        meta: { roles: 'admin-user' },
        component: () => import('pages/AtlasScenes.vue')
      }
    ]
  },
  {
    path: '/logout',
    beforeEnter: (_to, from, next) => {
      // Записуємо поточний урл в session storage
      // щоб потім на нього повернути після логіну
      sessionStorage.setItem('url-before-logout', from.path)

      // remove auth cookie
      cleanToken()
      next('/login')
    }
  },
  {
    path: '/login',
    component: () => import('layouts/Blank.vue'),
    children: [
      { path: '/login', component: () => import('pages/login/Login.vue') },
      { path: '/code', component: () => import('pages/login/Code.vue') }
    ]
  }
]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}

export default routes
